import axiosService from "services/axios.service";

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const getAnalytics = async (): Promise<any> => {
  const response = await axiosService.get(`${BASE_API_URL}/dashboard/analytics`);
  return response?.data?.data;
};

